var map = {
	"./agenda.png": "mTuW",
	"./agenda.svg": "4N9V",
	"./agenda_blanc.png": "qVz3",
	"./agendablanc.svg": "TkKH",
	"./calendar.svg": "MsC1",
	"./chat.png": "+SW8",
	"./chat.svg": "hkgD",
	"./chat_blanc.png": "VYNW",
	"./chat_blanc.svg": "gCox",
	"./chatblanc.svg": "+6wI",
	"./checking.png": "duY/",
	"./checking.svg": "Lcgk",
	"./checking_.svg": "MoJc",
	"./checking_blanc.png": "/duC",
	"./checking_blanc.svg": "++xh",
	"./checkingblanc.svg": "IFa9",
	"./dashboard.png": "EjgA",
	"./dashboard.svg": "0lX7",
	"./dashboard_blanc.png": "XNnC",
	"./dashboardblanc.svg": "axJk",
	"./documents.png": "/xVV",
	"./documents_blanc.png": "/Uhy",
	"./immeubles.png": "PnW6",
	"./immeubles.svg": "Wb4C",
	"./immeubles_blanc.png": "dCD7",
	"./immeubles_blanc.svg": "OL6q",
	"./immeublesblancs.svg": "B+Lo",
	"./service_book.png": "HoUs",
	"./service_book_blanc.png": "qGtB",
	"./settings.png": "hNTZ",
	"./site_monitoring.png": "/TH0",
	"./vehicle_check.png": "bTbd",
	"./vehicle_check_blanc.png": "jD3k"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uaVi";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/navigation nonrecursive \.(png|svg)$
// module id = uaVi
// module chunks = 0